import { RootState } from "@/lib/state/store";

export const animationSelector = (state: RootState) => {
  return state.animation;
};
